
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import { useNavigate } from 'react-router-dom';
import Config from "../../config.js";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from 'react-toastify';
import { Backdrop, CircularProgress } from "@mui/material";
import "rsuite/dist/rsuite.min.css";
import { useForm } from 'react-hook-form';
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { handleErrors, checkPrivilege } from "common.js";
import { PRIVILEGE } from "constants.js";

function EditTemplates() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [templateData, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const adminType = localStorage.getItem("type");
  const { id } = useParams();

  const { register, handleSubmit, setValue, setError, formState: { errors } } = useForm();

  const data = () => {
    setIsLoading(true)
    axios({
      // Endpoint to send files
      url: BASE + "api/configuration/viewTemplate/" + id,
      method: "GET",
      headers: {
        // Add any auth token here
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then(function (response) {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          setData(response.data),
            setValueFn(response.data.data)
        }
        else {
          if (message)
            toast.error(t(message))
              (function () {
                const redirectTimeout = setTimeout(() => {
                  clearTimeout(redirectTimeout);
                  navigate("/admin/emailTemplates");
                }, 3000);
              })()
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
        (function () {
          const redirectTimeout = setTimeout(() => {
            clearTimeout(redirectTimeout);
            navigate("/admin/emailTemplates");
          }, 3000);
        })()
      }
    })
      .catch(function (error) {
        setIsLoading(false);
        handleErrors(error, t, navigate);
      });
  }

  useEffect(() => {
    data();
  }, []);

  const setValueFn = (setValueData) => {
    setValue('id', setValueData.id);
    setValue('name', setValueData.name);
    setValue('subject', setValueData.subject);
    setValue('body', setValueData.body);
  }

  const onSubmit = async (data) => {
    setIsLoading(true);
    axios({
      // Endpoint to send files
      url: BASE + "api/configuration/editTemplate",
      method: "POST",
      data: data,
      headers: {
        // Add any auth token here
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then(function (response) {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          toast.success(t(message))
          const redirectTimeout = setTimeout(() => {
            clearTimeout(redirectTimeout);
            navigate('/admin/emailTemplates/', { replace: true });
          }, 2000);
        }
        else {
          if (message)
            toast.error(t(message))
          if (response.data.errors.length > 0)
            response.data.errors.forEach((error) => {
              setError(error.field, {
                type: 'server',
                message: error.errors[0]
              });
            })
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch(function (error) {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });

  };

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={t("Edit email template")} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {(Object.keys(templateData).length > 0) ?
        <MDBox pt={6} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox pt={3}>
                  <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
                    <MDBox px={3}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={4} md={4}>
                          <label className="labelStyle">{t("template name")}</label>
                        </Grid>
                        <Grid item xs={12} sm={8} md={8}>
                          <MDInput disabled={true} type="text" name="name"  {...register("name", { required: true })} fullWidth />
                          {errors.name && errors.name.type === "required" && (
                            <p className="errorMsg">{t('name field is mandatory')}</p>
                          )}
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                          <label className="labelStyle">Subject</label>
                        </Grid>
                        <Grid item xs={12} sm={8} md={8}>
                          <MDInput type="text" name="subject"  {...register("subject", { required: true })} fullWidth />
                          {errors.subject && errors.subject.type === "required" && (
                            <p className="errorMsg">{t('subject field is mandatory')}</p>
                          )}
                          {errors.subject && (
                            <p className="errorMsg">{t(errors.subject.message)}</p>
                          )}
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                          <label className="labelStyle">{t('body')}</label>
                        </Grid>
                        <Grid item xs={12} sm={8} md={8}>
                          <MDInput multiline rows={5} name="body"  {...register("body")} fullWidth />
                          {errors.body && errors.body.type === "required" && (
                            <p className="errorMsg">{t('body field is mandatory')}</p>
                          )}
                          {errors.body && (
                            <p className="errorMsg">{t(errors.body.message)}</p>
                          )}
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                        </Grid>
                        <Grid item xs={12} sm={8} md={8}>
                          {((adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && checkPrivilege("configuration", "write")))) ?
                            <MDButton type="submit" variant="gradient" color="info" className="edit-button-mb" disableRipple >
                              {t('update')}
                            </MDButton>
                            : null
                          }
                        </Grid>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        :
        <MDBox pt={6} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox>{t('noRecordsFound')}</MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      }
    </DashboardLayout>
  );
}

export default EditTemplates;
